import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-interactive-panels-engagement',
  templateUrl: './interactive-panels-engagement.component.html',
  styleUrls: ['./interactive-panels-engagement.component.scss']
})
export class InteractivePanelsEngagementComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('How Interactive Panels Improve Student Engagement & Learning Outcomes | Virsa');
    this.metaService.updateTag({ name: 'description', content: 'Discover the benefits of interactive panels in education. Improve student engagement and learning outcomes with Virsa smart classroom solutions and digital K-12 content.' });
    this.metaService.updateTag({ name: 'keywords', content: 'benefits of interactive panels in education, interactive panels for schools, smart classroom solutions India, K-12 digital learning, Virsa interactive flat panels' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
